/*
 * @FilePath     : /es-package/packages/es-mpx-storage/index.js
 * @Author       : LiYang
 * @Date         : 2022-02-08 10:40:15
 * @LastEditTime : 2022-02-08 20:36:17
 * @LastEditors  : Please set LastEditors
 * @Description  : 聚合基础方法
 */

import storage from './lib/storage'

export default (app) => {
  app.$storage = storage;
  
  app.injectMixins({
    onLaunch() {
      if (__mpx_mode__ === 'web') {
        return
      }
      storage.session.clear()
    }
  },{
    types: "app",
    stage: -999
  })
}